import { render, staticRenderFns } from "./utilizationDetail.vue?vue&type=template&id=4792d9d6&scoped=true"
import script from "./utilizationDetail.vue?vue&type=script&lang=js"
export * from "./utilizationDetail.vue?vue&type=script&lang=js"
import style0 from "./utilizationDetail.vue?vue&type=style&index=0&id=4792d9d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792d9d6",
  null
  
)

export default component.exports